import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { track } from '@/lib/analytics';
import { Button, Card } from '@/components';
import { FiXCircle } from 'react-icons/fi';

function PurchaseCancelPage() {
  const navigate = useNavigate();

  // Track screen view
  useEffect(() => {
    track('Purchase Cancel Screen');
  }, []);

  return (
    <div className='min-h-screen bg-sky-light flex items-center justify-center px-6'>
      <div className='max-w-md w-full'>
        <Card className='text-center py-12'>
          <FiXCircle className='w-16 h-16 text-gray-400 mx-auto mb-6' />
          <h1
            className='text-3xl font-semibold text-gray-900 mb-4'
            style={{
              fontFamily:
                "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            }}
          >
            Purchase Cancelled
          </h1>
          <p className='text-lg text-gray-600 mb-8'>
            Your purchase was cancelled. No charges were made to your account.
          </p>

          <div className='space-y-3'>
            <Button
              fullWidth
              onClick={() => navigate({ to: '/purchase', search: { ticket: undefined } })}
            >
              Try Again
            </Button>
            <Button
              fullWidth
              variant='secondary'
              onClick={() => navigate({ to: '/', search: { hero: undefined } })}
            >
              Return to Home
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/purchase/cancel')({
  component: PurchaseCancelPage,
});
